"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceCommercial = void 0;
const typebox_1 = require("@sinclair/typebox");
// Correct to the SendGrid template as of 2023-08-12 -JD
exports.InvoiceCommercial = typebox_1.Type.Object({
    first_name: typebox_1.Type.Optional(typebox_1.Type.String()),
    subscription_number: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoice_number: typebox_1.Type.Optional(typebox_1.Type.String()),
    custom_message: typebox_1.Type.Optional(typebox_1.Type.String()),
    due_date: typebox_1.Type.String(),
    payment_link: typebox_1.Type.Optional(typebox_1.Type.String()),
    allow_check: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    allow_ach: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
//# sourceMappingURL=invoice-commercial.js.map